export default __webpack_public_path__ + "static/media/logo-facebook.0dd5c9b9.svg";